import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinDetailAccount = createAsyncThunk(
    "detailAccount/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterDetailAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getDetailAccount = createAsyncThunk(
    "detailAccount/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMasterDetailAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertDetailAccount = createAsyncThunk(
    "detailAccount/insert",
    async ({MainAccountID, SubAccountID, SubGroupAccountID, DetailAccount, DetailAccountID, Saldo}, thunkAPI) => {
        let formData = new FormData();
        formData.append("MainAccountID", MainAccountID);
        formData.append("SubAccountID", SubAccountID);
        formData.append("SubGroupAccountID", SubGroupAccountID);
        formData.append("DetailAccount", DetailAccount);
        formData.append("DetailAccountID", DetailAccountID);
        formData.append("Saldo", Saldo);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertMasterDetailAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateDetailAccount = createAsyncThunk(
    "detailAccount/update",
    async ({
               MainAccountID,
               SubAccountID,
               SubGroupAccountID,
               DetailAccount,
               DetailAccountID,
               Saldo,
               status
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("MainAccountID", MainAccountID);
        formData.append("SubAccountID", SubAccountID);
        formData.append("SubGroupAccountID", SubGroupAccountID);
        formData.append("DetailAccount", DetailAccount);
        formData.append("DetailAccountID", DetailAccountID);
        formData.append("status", status);
        formData.append("Saldo", Saldo);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateMasterDetailAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const detailAccountSlice = createSlice({
    name: "detailAccount",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinDetailAccount.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinDetailAccount.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinDetailAccount.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getDetailAccount.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getDetailAccount.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getDetailAccount.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertDetailAccount.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertDetailAccount.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertDetailAccount.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateDetailAccount.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateDetailAccount.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateDetailAccount.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const detailAccountSelector = (state) => state.detailAccount;
